import type { IconSvgObject } from './types';

const PilcrowIcon: IconSvgObject = [
  ["path", { d: "M12.9922 3V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.9922 3V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18.9922 3H9.49219C8.29871 3 7.15412 3.47411 6.31021 4.31802C5.46629 5.16193 4.99219 6.30653 4.99219 7.5C4.99219 8.69347 5.46629 9.83807 6.31021 10.682C7.15412 11.5259 8.29871 12 9.49219 12H12.9922", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PilcrowIcon;
